import React, { useEffect, useState } from 'react'
import { ButtonBack, ButtonNext, CarouselProvider, Slide, Slider } from 'pure-react-carousel'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { withTheme } from 'theming'
import { isEmpty } from 'lodash'
import useTemplateHook from '../templateHook'
import EditMenu from '../editMenu'
import useAxios from 'axios-hooks'
import AddSection from '../addSection'
import { encodeURI } from 'js-base64'
import NewContentCard from '../../contentCard/newContentCard'
import './newSwimlane.css'
import LoaderTile from '../../contentCard/loaderTile'
import { useTranslation } from 'react-i18next'
import { EMPTY_STRING_HASH } from '../../../utils/constants'
import ContentHoverCardSmall from '../../contentCard/contentHoverCardSmall'

const SmoothHorizonCards = ({
  componentData,
  modifyData,
  setModalState,
  isEdit = true,
  onDelete,
  onSwap,
  onCopy,
  theme,
  onAdd,
}) => {
  //   const { data, title, filters, seeMoreVisible, type, theme } = props
  const { t } = useTranslation()
  const { data, id } = componentData
  const [hoverState, setHoverState] = useState('')
  const {
    customNavigate,
    isBrowser,
    LG_SIZE,
    SM_SIZE,
    CONTENT_FILTER_XAVIER,
    KalingoLeftArrow,
    KalingoRightArrow,
  } = useTemplateHook()
  const [hoverCardIndex, setHoverCardIndex] = useState('')
  const [visibleSlides, setVisibleSlides] = useState(2)
  const [contentData, setContentData] = useState([])
  const language = localStorage.getItem('language') || 'en'

  const [{ data: contentList, loading: contentListLoading }, contentListCall] = useAxios(
    {
      url: CONTENT_FILTER_XAVIER,
      method: 'post',
    },
    { manual: true },
  )

  const handleResize = () => {
    if (window.innerWidth >= LG_SIZE) {
      setVisibleSlides(6)
    } else if (window.innerWidth < LG_SIZE && window.innerWidth >= SM_SIZE) {
      setVisibleSlides(3)
    } else {
      setVisibleSlides(2)
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  useEffect(() => {
    if (!isEmpty(data.content_data) || !isEmpty(data.auto_payload)) {
      let filterPayload =
        data.type === 'STATIC'
          ? { content_ids: data.content_data }
          : {
              system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
              custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
              video_types: ['SPV', 'MPVP', 'MPVC', 'LIVE', 'VOD_LIVE', 'PLAYLIST'],
            }

      contentListCall({
        data: {
          filters: filterPayload,
          page: 1,
          order_by:
            data.type === 'STATIC'
              ? ''
              : data?.order_by === 'title'
              ? `title.${language}`
              : data?.order_by,
          reverse: data.type === 'STATIC' ? '' : data?.reverse,
          page_size: 15,
        },
      })
    } else {
      setContentData([])
    }
  }, [data])

  useEffect(() => {
    if (contentList && contentList.success) {
      if (data.type === 'STATIC') {
        contentList?.data.sort((a, b) => {
          let sortingArr = data.content_data
          return sortingArr.indexOf(a.content_id) - sortingArr.indexOf(b.content_id)
        })
      }
      setContentData(contentList.data)
    }
  }, [contentList])

  const handleHover = (index) => {
    if (isEdit) return
    setHoverCardIndex(index)
  }

  const handleUnHover = () => {
    if (isEdit) return
    setHoverCardIndex('')
  }

  const handleSeeMore = () => {
    let payloadObj = {
      filters: {},
      order_by:
        data.type === 'STATIC'
          ? ''
          : data?.order_by === 'title'
          ? `title.${language}`
          : data?.order_by,
      reverse: data.type === 'STATIC' ? '' : data?.reverse,
    }
    payloadObj.filters =
      data.type === 'STATIC'
        ? {
            content_ids: data.content_data,
          }
        : {
            system_defined: data.auto_payload.filter((info) => info.type === 'system_defined'),
            custom_defined: data.auto_payload.filter((info) => info.type === 'custom_defined'),
          }
    const encoded = encodeURI(JSON.stringify(payloadObj))
    customNavigate(
      'DIRECT',
      `/content/filter/${encodeURI(data.name || EMPTY_STRING_HASH)}?filters=${encoded}`,
      isEdit,
    )
  }

  const handleHoverItems = (name) => {
    // if (!isEdit) return
    setHoverState(name)
  }

  const handleModal = () => {
    setModalState({
      keyID: id,
      modalData: data,
    })
  }

  const handleAddModal = () => {
    onAdd({
      keyID: id,
      modalData: data,
    })
  }

  const getStyleValue = (parentKey, childKey, defaultValue) => {
    if (!data?.style_config) {
      return defaultValue ? defaultValue : ''
    }

    let tempArr = data?.style_config[parentKey]?.data.filter((info) => info.key === childKey)

    return !isEmpty(tempArr) ? (tempArr[0].value ? tempArr[0].value : defaultValue) : defaultValue
  }

  return (
    <div
      className={`${isEdit && hoverState && 'component-hover-class'} relative py-2 xl:py-6`}
      style={{
        backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
        zIndex: hoverState ? 2 : 1,
      }}
      onMouseOver={() => handleHoverItems(`TOP`)}
      onMouseLeave={() => handleHoverItems('')}
    >
      {isEdit && hoverState.length > 0 && (
        <EditMenu
          onEdit={() => handleModal()}
          onDelete={() => onDelete(id)}
          onCopy={() => onCopy(id)}
          onMoveUp={() => onSwap(id, 'up')}
          onMoveDown={() => onSwap(id, 'down')}
        />
      )}

      <CarouselProvider
        naturalSlideWidth={isBrowser ? 100 : 300}
        naturalSlideHeight={isBrowser ? 100 : 195}
        totalSlides={contentData.length}
        visibleSlides={visibleSlides}
        step={visibleSlides}
      >
        <div
          className="flex items-baseline "
          style={{
            padding: '0 3.66032%',
          }}
        >
          <p
            style={{
              color: getStyleValue('heading', 'color', theme.c3),
              fontFamily: getStyleValue('heading', 'font', ''),
              textAlign: getStyleValue('heading', 'alignment', 'left'),
            }}
            className={`xl:text-2xl md:text-xl text-xs font-bold w-full ${getStyleValue(
              'heading',
              'font_format',
              'font-bold',
            )} mb-0`}
          >
            {data?.name}
            {contentData.length > 14 && (
              <span
                style={{ cursor: 'pointer' }}
                className={
                  'text-blue-400 text-xs md:text-md  ml-2 cursor-pointer hover:opacity z-30 mt-3'
                }
                onClick={handleSeeMore}
              >
                {t('see_more')}
              </span>
            )}
          </p>
        </div>
        <div
          className={`swimlane-container-dock smooth-horizon-slider-class h-[8.5rem] md:h-[12rem]`}
          style={{
            backgroundColor: getStyleValue('component_background', 'primary_color', theme.c1),
          }}
        >
          <Slider
            style={
              {
                //   minHeight: hoverCardIndex !== '' && isBrowser ? `16rem` : 'unset',
                //   maxHeight: '320px',
              }
            }
            className="pt-2 xl:pt-3"
          >
            {contentData.map((item, index) => {
              return (
                <Slide key={index} index={index} className="">
                  <div
                    style={{ display: hoverCardIndex === index && isBrowser ? 'block' : 'none' }}
                    className="relative"
                    onMouseLeave={handleUnHover}
                  >
                    {!index ? (
                      <div className="z-0 opacity-0">
                        <NewContentCard data={item} type={'content'} isSquareBorder />
                      </div>
                    ) : null}
                    <ContentHoverCardSmall
                      data={item}
                      type={'content'}
                      position={index + 1}
                      total={contentData?.length}
                      isVisible={hoverCardIndex === index && isBrowser}
                      isSquareBorder
                    />
                  </div>

                  {contentListLoading ? (
                    <LoaderTile height={'auto'} />
                  ) : (
                    <div
                      className="relative"
                      style={{ opacity: hoverCardIndex === index && isBrowser ? 0 : 1 }}
                      onMouseOver={() => handleHover(index)}
                    >
                      <NewContentCard
                        textStyle={{
                          color: getStyleValue('card_style', 'color', theme.c4),
                          fontFamily: getStyleValue('card_style', 'font', ''),
                        }}
                        fontFormat={getStyleValue('card_style', 'font_format', 'font-bold')}
                        data={item}
                        type={'content'}
                        isEdit={isEdit}
                        isSquareBorder
                      />
                    </div>
                  )}
                </Slide>
              )
            })}
          </Slider>
          {isBrowser && (
            <>
              {contentData.length > visibleSlides ? (
                <ButtonBack className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-left-arrow-small flex items-center justify-center"
                  >
                    <img src={KalingoLeftArrow} style={{ height: '37px' }} alt="KalingoLeftArrow" />
                  </div>
                </ButtonBack>
              ) : null}
              {contentData.length > visibleSlides ? (
                <ButtonNext className="">
                  <div
                    style={{
                      backgroundColor: getStyleValue(
                        'component_background',
                        'primary_color',
                        theme.c1,
                      ),
                    }}
                    className="kalingo-right-arrow-small flex items-center justify-center"
                  >
                    <img
                      src={KalingoRightArrow}
                      style={{ height: '37px' }}
                      alt="KalingoLeftArrow"
                    />
                  </div>
                </ButtonNext>
              ) : null}
            </>
          )}
        </div>
      </CarouselProvider>
      {isEdit && hoverState.length > 0 && <AddSection openAdd={handleAddModal} />}
    </div>
  )
}

export default withTheme(SmoothHorizonCards)
